import moment from 'moment'

const dateFormat = 'YYYY-MM-DD'

export function setDefaultLocalFlightDate() {
    localStorage.hasOwnProperty('flightDate')
        || localStorage.setItem('flightDate', moment.utc().format(dateFormat))
}

export function setLocalFlightDate(flightDate) {
    localStorage.setItem('flightDate', flightDate.format(dateFormat))
}

export function getLocalFlightDate() {
    return localStorage.hasOwnProperty('flightDate')
        ? moment.utc(localStorage.getItem('flightDate'), dateFormat)
        : moment.utc()
}

export function cleanLocalFlightDate() {
    localStorage.removeItem('flightDate')
}


// WEBPACK FOOTER //
// ./src/shared/utils/localFlightDate.js